
























import {defineComponent, Ref, ref} from "@vue/composition-api"

export default defineComponent({
  name: 'AutoComplete',
  props: {
    suggestions: {}
  },
  setup({suggestions}: { suggestions: string[] }) {
    const currentFocus = ref(0)
    const activeSuggestions: Ref<string[]> = ref([])
    const inputModel: Ref<string> = ref("")
    const isInvalid = ref<boolean>(false)

    document.onclick = () => {
      activeSuggestions.value = []
    }
    return {
      activeSuggestions,
      isInvalid,
      inputModel,
      currentFocus,

      highlightInputInSuggestion: function(value: string) {
        return value.replace(inputModel.value, `<b>${inputModel.value}</b>`)
      },
      onInput: () => {
        if (!inputModel.value) {
          activeSuggestions.value = []
          return
        }
        activeSuggestions.value = suggestions
          .filter((x: string) => x.toLowerCase().includes(inputModel.value.toLowerCase()))
          .filter((_: string, index: number) => index < 5)
        currentFocus.value = 0
      },
      onEnter: () => {
        if (activeSuggestions.value.length === 0) return
        inputModel.value = activeSuggestions.value[currentFocus.value]
        activeSuggestions.value = []
        isInvalid.value = false
      },
      onSuggestionClicked(x: string) {
        inputModel.value = x
        isInvalid.value = false
      },
      validate: () => {
        isInvalid.value = inputModel.value.length > 0 && !suggestions.includes(inputModel.value)
      }
    }
  }
})
